export default {
  background_image: 'Background Image',
};
